export const FETCH_LESSON_INFO = "[Lesson] Fetch Lesson Info";
